import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "d-inline-flex align-items-center gap-1 bg-secondary-subtle text-secondary px-3 py-1 rounded-2 fs-12" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "row g-3 mb-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 1,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_11 = { class: "mt-2 pt-2 border-top d-flex gap-2" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "btn btn-xs btn-primary btn-sm fs-11 mb-0 cursor-pointer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 1,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_19 = { class: "mt-2 pt-2 border-top d-flex gap-2" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "btn btn-xs btn-danger btn-sm fs-11 mb-0 cursor-pointer" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "p-3 border rounded-3 h-100 bg-light-subtle d-flex flex-column justify-content-between" }
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 1,
  class: "text-muted fs-12 mb-2 italic"
}
const _hoisted_27 = { class: "mt-2 pt-2 border-top d-flex gap-2" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_31 = { class: "p-3 rounded-3 bg-light border mb-4" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_33 = { class: "text-muted fs-12 d-flex align-items-center flex-wrap gap-2" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "p-2 mb-3 bg-white rounded border" }
const _hoisted_36 = { class: "d-flex gap-4" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = { class: "form-check" }
const _hoisted_39 = { class: "row g-3 mb-3" }
const _hoisted_40 = { class: "col-md-8" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = {
  key: 0,
  class: "text-primary fs-11 mt-1"
}
const _hoisted_43 = {
  key: 0,
  class: "alert alert-warning py-2 px-3 fs-12 mb-3 rounded-2 d-flex justify-content-between align-items-center flex-wrap gap-2"
}
const _hoisted_44 = { class: "d-flex align-items-center gap-2" }
const _hoisted_45 = { class: "text-dark" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "pt-2 border-top" }
const _hoisted_48 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-2 mb-2 fs-11 text-muted"
}
const _hoisted_49 = { class: "material-symbols-outlined fs-14" }
const _hoisted_50 = { class: "material-symbols-outlined fs-14" }
const _hoisted_51 = { class: "d-flex justify-content-end align-items-center flex-wrap gap-2" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled", "title"]
const _hoisted_54 = ["disabled", "title"]
const _hoisted_55 = {
  key: 0,
  class: "p-3 rounded-3 bg-warning-subtle border border-warning mb-4"
}
const _hoisted_56 = { class: "row g-2 mb-2" }
const _hoisted_57 = { class: "col-md-8" }
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = { class: "d-flex justify-content-end" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_62 = { class: "border rounded-3 overflow-hidden" }
const _hoisted_63 = { class: "bg-light-subtle py-2 px-3 border-bottom d-flex justify-content-between align-items-center" }
const _hoisted_64 = { class: "badge bg-secondary-subtle text-secondary fs-11" }
const _hoisted_65 = { class: "table-responsive" }
const _hoisted_66 = { class: "table table-hover align-middle mb-0 fs-13" }
const _hoisted_67 = { class: "text-muted text-nowrap fs-12" }
const _hoisted_68 = { class: "fs-12 text-dark fw-medium mt-1" }
const _hoisted_69 = { class: "fs-11 text-muted" }
const _hoisted_70 = { class: "text-break fs-12 text-dark" }
const _hoisted_71 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_72 = ["href", "title"]
const _hoisted_73 = { class: "text-truncate" }
const _hoisted_74 = ["onClick", "disabled"]
const _hoisted_75 = {
  key: 1,
  class: "text-muted fs-12"
}
const _hoisted_76 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
        _createElementVNode("span", { class: "material-symbols-outlined text-success fs-22" }, "verified_user"),
        _createElementVNode("h5", { class: "mb-0 fs-15 fw-bold text-dark" }, "Deliverables Resmi & Quality Control (QC)")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge px-3 py-2 fs-12", _ctx.qcStatusBadgeClass(_ctx.order.qc_status)])
        }, " QC: " + _toDisplayString(_ctx.order.qc_status || 'PENDING'), 3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, "Run " + _toDisplayString(_ctx.order.current_revision_run || 1) + " / " + _toDisplayString(_ctx.order.max_revision_runs || 1), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-xs btn-link p-0 text-primary text-decoration-none d-flex align-items-center ms-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openEditMaxRunsPrompt && _ctx.openEditMaxRunsPrompt(...args))),
            title: "Ubah Kuota Batas Maksimal Revisi Pelanggan"
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("span", { class: "material-symbols-outlined fs-15" }, "edit", -1)
          ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[57] || (_cache[57] = _createElementVNode("h6", { class: "fs-14 fw-bold text-dark mb-3" }, "3 Berkas Luaran Resmi (Deliverables) Sesuai SOP RBN", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
                _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-20" }, "description"),
                _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "1. Naskah Hasil (.docx)")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-muted fs-12 mb-2" }, "Naskah hasil perbaikan / parafrase final.", -1)),
              (_ctx.order.final_manuscript_docx)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-success fs-12 fw-medium text-truncate mb-2",
                    title: _ctx.getFilename(_ctx.order.final_manuscript_docx)
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "check_circle", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFilename(_ctx.order.final_manuscript_docx)), 1)
                  ], 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "Belum diunggah"))
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.order.final_manuscript_docx)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.getFileUrl(_ctx.order.final_manuscript_docx),
                    target: "_blank",
                    class: "btn btn-xs btn-outline-primary btn-sm fs-11"
                  }, " Unduh ", 8, _hoisted_12))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_13, [
                _cache[21] || (_cache[21] = _createTextVNode(" Unggah DOCX ")),
                _createElementVNode("input", {
                  type: "file",
                  class: "d-none",
                  accept: ".docx,.doc",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadDocx && _ctx.uploadDocx(...args))),
                  disabled: _ctx.uploadingDocx
                }, null, 40, _hoisted_14)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
                _createElementVNode("span", { class: "material-symbols-outlined text-danger fs-20" }, "picture_as_pdf"),
                _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "2. Laporan Asli Software (.pdf)")
              ], -1)),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-muted fs-12 mb-2" }, "Laporan asli Turnitin / Grammarly / AI detector.", -1)),
              (_ctx.order.raw_vendor_pdf)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-success fs-12 fw-medium text-truncate mb-2",
                    title: _ctx.getFilename(_ctx.order.raw_vendor_pdf)
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "check_circle", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFilename(_ctx.order.raw_vendor_pdf)), 1)
                  ], 8, _hoisted_17))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, "Belum diunggah"))
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.order.raw_vendor_pdf)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.getFileUrl(_ctx.order.raw_vendor_pdf),
                    target: "_blank",
                    class: "btn btn-xs btn-outline-danger btn-sm fs-11"
                  }, " Buka PDF ", 8, _hoisted_20))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_21, [
                _cache[25] || (_cache[25] = _createTextVNode(" Unggah PDF Asli ")),
                _createElementVNode("input", {
                  type: "file",
                  class: "d-none",
                  accept: ".pdf",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadVendorPdf && _ctx.uploadVendorPdf(...args))),
                  disabled: _ctx.uploadingPdf
                }, null, 40, _hoisted_22)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
                _createElementVNode("span", { class: "material-symbols-outlined text-success fs-20" }, "verified"),
                _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "3. Protokol Resmi RBN A4")
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-muted fs-12 mb-2" }, "Sertifikat protokol ber-QR Code resmi auto-generate.", -1)),
              (_ctx.order.generated_protocol_pdf)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text-success fs-12 fw-medium text-truncate mb-2",
                    title: _ctx.getFilename(_ctx.order.generated_protocol_pdf)
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "material-symbols-outlined fs-14 align-middle" }, "check_circle", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFilename(_ctx.order.generated_protocol_pdf)), 1)
                  ], 8, _hoisted_25))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, "Otomatis saat simpan protokol"))
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.order.generated_protocol_pdf)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.getFileUrl(_ctx.order.generated_protocol_pdf),
                    target: "_blank",
                    class: "btn btn-xs btn-success btn-sm fs-11"
                  }, " Buka Dokumen ", 8, _hoisted_28))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generateProtocolPdf && _ctx.generateProtocolPdf(...args))),
                disabled: _ctx.generating,
                class: "btn btn-xs btn-outline-success btn-sm fs-11"
              }, [
                (_ctx.generating)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                  : _createCommentVNode("", true),
                _cache[29] || (_cache[29] = _createTextVNode(" Generate PDF "))
              ], 8, _hoisted_29)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[32] || (_cache[32] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-0 d-flex align-items-center gap-2" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-18" }, "rule"),
            _createElementVNode("span", null, "Evaluasi & Keputusan Quality Control (QC)")
          ], -1)),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("span", null, [
              _cache[30] || (_cache[30] = _createTextVNode(" Status Izin Revisi Pelanggan: ")),
              _createElementVNode("strong", {
                class: _normalizeClass(_ctx.order.revision_allowed ? 'text-success' : 'text-danger')
              }, _toDisplayString(_ctx.order.revision_allowed ? 'DIBUKA' : 'DITUTUP'), 3),
              _createTextVNode(" (Tersisa " + _toDisplayString(Math.max(0, (_ctx.order.max_revision_runs || 1) - (_ctx.order.current_revision_run || 1))) + " kesempatan dari total " + _toDisplayString(_ctx.order.max_revision_runs || 1) + " Run) ", 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs btn-outline-primary py-0 px-2 fs-11 d-inline-flex align-items-center gap-1",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addRevisionRunQuota && _ctx.addRevisionRunQuota(...args))),
              disabled: _ctx.updatingQc,
              title: "Tambah kuota batas revisi pelanggan sebanyak 1 run"
            }, _cache[31] || (_cache[31] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "add_circle", -1),
              _createElementVNode("span", null, "Buka Limit (+1 Run)", -1)
            ]), 8, _hoisted_34)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary mb-1" }, "Tujuan Evaluasi QC:", -1)),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "qcTarget",
                id: "targetEditor",
                value: "editor",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.qcTarget) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.qcTarget]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "form-check-label fs-13 text-dark cursor-pointer",
                for: "targetEditor"
              }, [
                _createElementVNode("strong", null, "Ke Editor"),
                _createTextVNode(),
                _createElementVNode("span", { class: "text-muted" }, "(Internal - perbaikan pengerjaan/protokol)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "qcTarget",
                id: "targetPelanggan",
                value: "pelanggan",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.qcTarget) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.qcTarget]
              ]),
              _cache[34] || (_cache[34] = _createElementVNode("label", {
                class: "form-check-label fs-13 text-dark cursor-pointer",
                for: "targetPelanggan"
              }, [
                _createElementVNode("strong", null, "Ke Pelanggan"),
                _createTextVNode(),
                _createElementVNode("span", { class: "text-muted" }, "(Eksternal - kembalikan untuk revisi / tanggapan)")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary" }, "Catatan Evaluasi / Instruksi QC", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control form-control-sm fs-13",
              rows: "3",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.qcNotes) = $event)),
              placeholder: "Tuliskan catatan hasil review QC untuk editor atau instruksi perbaikan untuk pelanggan..."
            }, null, 512), [
              [_vModelText, _ctx.qcNotes]
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold text-secondary" }, "Lampiran Berkas QC (Opsional)", -1)),
            _createElementVNode("input", {
              type: "file",
              class: "form-control form-control-sm fs-12",
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onQcAttachmentChange && _ctx.onQcAttachmentChange(...args)))
            }, null, 32),
            (_ctx.qcAttachment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, " File terpilih: " + _toDisplayString(_ctx.qcAttachment.name), 1))
              : _createCommentVNode("", true),
            _cache[38] || (_cache[38] = _createElementVNode("small", { class: "text-muted fs-11 d-block mt-1" }, "Sertakan berkas markup, anotasi review, atau referensi jika ada.", -1))
          ])
        ]),
        (_ctx.qcTarget === 'pelanggan' && (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "material-symbols-outlined text-warning-emphasis fs-18" }, "lock_clock", -1)),
                _createElementVNode("span", _hoisted_45, "Batas kuota revisi pelanggan telah mencapai batas maksimum (" + _toDisplayString(_ctx.order.current_revision_run || 1) + " dari " + _toDisplayString(_ctx.order.max_revision_runs || 1) + " Run). Ingin membuka limit revisi tambahan untuk pelanggan?", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary py-1 px-3 fs-12 d-inline-flex align-items-center gap-1",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addRevisionRunQuota && _ctx.addRevisionRunQuota(...args))),
                disabled: _ctx.updatingQc
              }, _cache[40] || (_cache[40] = [
                _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "add_circle", -1),
                _createElementVNode("span", null, "Buka Limit (+1 Run Revisi)", -1)
              ]), 8, _hoisted_46)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_47, [
          (!_ctx.canApproveQc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "fw-medium text-secondary" }, "Syarat Approve QC:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.hasResultDocument ? 'text-success fw-medium' : 'text-danger', "d-inline-flex align-items-center gap-1"])
                }, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.hasResultDocument ? 'check_circle' : 'cancel'), 1),
                  _cache[41] || (_cache[41] = _createElementVNode("span", null, "1 Dokumen Hasil", -1))
                ], 2),
                _cache[44] || (_cache[44] = _createElementVNode("span", null, "•", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.hasGeneratedProtocol ? 'text-success fw-medium' : 'text-danger', "d-inline-flex align-items-center gap-1"])
                }, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.hasGeneratedProtocol ? 'check_circle' : 'cancel'), 1),
                  _cache[42] || (_cache[42] = _createElementVNode("span", null, "Generate Protokol", -1))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            (_ctx.qcTarget === 'editor')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateQc('RETURN_TO_EDITOR', false, undefined, 'editor', 'QC'))),
                  disabled: _ctx.updatingQc,
                  class: "btn btn-sm btn-outline-warning d-flex align-items-center gap-1"
                }, _cache[45] || (_cache[45] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "undo", -1),
                  _createElementVNode("span", null, "Kembalikan ke Editor", -1)
                ]), 8, _hoisted_52))
              : _createCommentVNode("", true),
            (_ctx.qcTarget === 'pelanggan')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateQc('REVISE_BY_USER', true, undefined, 'pelanggan', 'QC'))),
                  disabled: _ctx.updatingQc || (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1),
                  class: "btn btn-sm btn-outline-danger d-flex align-items-center gap-1",
                  title: (_ctx.order.current_revision_run || 1) >= (_ctx.order.max_revision_runs || 1) ? 'Batas maksimal kuota revisi pelanggan telah tercapai' : ''
                }, _cache[46] || (_cache[46] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "undo", -1),
                  _createElementVNode("span", null, "Kembalikan ke Pelanggan", -1)
                ]), 8, _hoisted_53))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateQc('APPROVED', false, 'Completed', 'editor', 'QC'))),
              disabled: _ctx.updatingQc || !_ctx.canApproveQc,
              class: "btn btn-sm btn-success d-flex align-items-center gap-1",
              title: !_ctx.canApproveQc ? 'Lengkapi minimal 1 dokumen hasil dan generate protokol untuk Approve QC' : 'Approve QC dan Selesaikan Pesanan'
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "check_circle", -1),
              _createElementVNode("span", null, "Approve QC & Selesaikan Pesanan", -1)
            ]), 8, _hoisted_54)
          ])
        ])
      ]),
      (_ctx.order.qc_status === 'RETURN_TO_EDITOR')
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "d-flex align-items-center gap-2 mb-2" }, [
              _createElementVNode("span", { class: "material-symbols-outlined text-warning-emphasis fs-20" }, "assignment_return"),
              _createElementVNode("h6", { class: "fs-13 fw-bold text-warning-emphasis mb-0" }, "Tanggapan Editor ke QC (Perbaikan Naskah / Protokol Selesai)")
            ], -1)),
            _cache[51] || (_cache[51] = _createElementVNode("p", { class: "fs-12 text-muted mb-2" }, " Pesanan ini dikembalikan oleh QC untuk dilakukan perbaikan. Setelah selesai memperbarui protokol atau naskah, silakan kirimkan tanggapan di bawah ini untuk diajukan kembali ke QC. (Menyimpan protokol di tab bawah juga akan otomatis mencatat tanggapan editor). ", -1)),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-13",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editorReplyNotes) = $event)),
                  placeholder: "Tuliskan keterangan perbaikan yang telah dilakukan..."
                }, null, 512), [
                  [_vModelText, _ctx.editorReplyNotes]
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control form-control-sm fs-12",
                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onEditorAttachmentChange && _ctx.onEditorAttachmentChange(...args)))
                }, null, 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitEditorReply && _ctx.submitEditorReply(...args))),
                disabled: _ctx.replyingQc,
                class: "btn btn-sm btn-warning d-flex align-items-center gap-1 text-dark fw-medium"
              }, [
                (_ctx.replyingQc)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61))
                  : _createCommentVNode("", true),
                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "send", -1)),
                _cache[49] || (_cache[49] = _createElementVNode("span", null, "Kirim Tanggapan & Ajukan Kembali ke QC", -1))
              ], 8, _hoisted_60)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _cache[52] || (_cache[52] = _createElementVNode("div", { class: "d-flex align-items-center gap-2" }, [
            _createElementVNode("span", { class: "material-symbols-outlined text-secondary fs-18" }, "history"),
            _createElementVNode("span", { class: "fw-bold fs-13 text-dark" }, "Riwayat & Log Interaksi QC (Audit Trail)")
          ], -1)),
          _createElementVNode("span", _hoisted_64, _toDisplayString((_ctx.order.qc_histories && _ctx.order.qc_histories.length) || 0) + " Aktivitas ", 1)
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("table", _hoisted_66, [
            _cache[56] || (_cache[56] = _createElementVNode("thead", { class: "table-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Waktu"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Pengirim"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"12%"}
                }, "Tujuan"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"15%"}
                }, "Status & Run"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"25%"}
                }, "Catatan / Pesan"),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"width":"18%"}
                }, "Berkas & Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.order.qc_histories || []), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.formatDateTime(item.created_at)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.senderBadgeClass(item.sender_type)])
                    }, _toDisplayString(item.sender_type), 3),
                    _createElementVNode("div", _hoisted_68, _toDisplayString(item.user?.name || item.customer?.name || (item.sender_type === 'PELANGGAN' ? _ctx.order.customer?.name : 'User')), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.targetBadgeClass(item.target)])
                    }, " Ke " + _toDisplayString(_ctx.formatTarget(item.target)), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge px-2 py-1 fs-11 mb-1 d-inline-block", _ctx.qcStatusBadgeClass(item.qc_status)])
                    }, _toDisplayString(item.qc_status || '-'), 3),
                    _createElementVNode("div", _hoisted_69, " Run ke-" + _toDisplayString(item.revision_run || 1), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_70, _toDisplayString(item.notes || '-'), 1)
                  ]),
                  _createElementVNode("td", null, [
                    (item.attachment_file)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("a", {
                            href: _ctx.getFileUrl(item.attachment_file),
                            target: "_blank",
                            class: "btn btn-xs btn-outline-secondary d-inline-flex align-items-center gap-1 text-truncate",
                            style: {"max-width":"200px"},
                            title: _ctx.getFilename(item.attachment_file)
                          }, [
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "attach_file", -1)),
                            _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.getFilename(item.attachment_file)), 1)
                          ], 8, _hoisted_72),
                          _createElementVNode("button", {
                            class: "btn btn-xs btn-outline-primary d-inline-flex align-items-center gap-1 fw-medium",
                            onClick: ($event: any) => (_ctx.setPrimaryFile(item.attachment_file)),
                            disabled: _ctx.settingPrimary,
                            title: "Gantikan naskah utama pesanan dengan berkas ini"
                          }, _cache[54] || (_cache[54] = [
                            _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "swap_horizontal_circle", -1),
                            _createElementVNode("span", null, "Jadikan File Utama untuk Diedit", -1)
                          ]), 8, _hoisted_74)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_75, "-"))
                  ])
                ]))
              }), 128)),
              (!_ctx.order.qc_histories || _ctx.order.qc_histories.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_76, _cache[55] || (_cache[55] = [
                    _createElementVNode("td", {
                      colspan: "6",
                      class: "text-center py-4 text-muted fs-12"
                    }, [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-24 d-block mb-1 text-muted" }, "receipt_long"),
                      _createTextVNode(" Belum ada catatan riwayat QC pada pesanan ini. ")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}